/***
 *
 *   FORGOT PASSWORD
 *   Phase 9 — reference forgot-password chrome.
 *
 **********/

import React, { useState } from 'react';
import { Animate, Form, Message, Link } from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { useTranslate } from 'app/translations';

export function ForgotPassword(props) {
    const { _t } = useTranslate();
    const [sent, setSent] = useState(false);

    return (
        <Animate type="pop">
            <AuthPage
                title={_t('password.reset.label')}
                description={_t('password.forgot.info')}
                footer={
                    <>
                        <Link url="/signin" text={_t('signin.label')} />
                    </>
                }>
                {sent ? (
                    <Message
                        title={_t('email.check')}
                        type="success"
                        text={_t('password.forgot.info')}
                    />
                ) : (
                    <Form
                        data={{
                            email: {
                                label: _t('email.label'),
                                type: 'email',
                                required: true,
                            },
                        }}
                        url="/api/auth/password/reset/request"
                        auth={false}
                        method="POST"
                        buttonText={_t('password.reset.text')}
                        callback={() => setSent(true)}
                    />
                )}
            </AuthPage>
        </Animate>
    );
}
